/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";
import StyledWrapper from '@insite/client-framework/Common/StyledWrapper';
import SkeletonLoader from '@NA/Components/Coveo/CoveoSkeletonBox';
import { HasCoveoHooks, withCoveoHooks } from '@NA/Components/Coveo/Contexts/CoveoHooksContext';

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    itemsText?: TypographyPresentationProps;
    queryText?: TypographyPresentationProps;
    showingText?: InjectableCss;
}
export const summaryStyles: ProductListProductCountStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
        `,
    },
    countText: {
        css: css`
            white-space: nowrap;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
        `,
    },
    queryText: {
        css: css`
            display: block;
            width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: bold;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 15px;
                    `,
                    css`
                        margin-left: 15px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 15px;
                    `,
                ])}
        `,
    },
    showingText: {
        css: css`
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = summaryStyles;

type Props = HasCoveoHooks;

const CoveoQuerySummary: React.FC<Props> = ({
    summary
}) => {
    const total = summary.state?.totalNumberOfProducts;
    const start = summary.state?.firstProduct;
    const end = summary.state?.lastProduct;

    if (!start || !end || !total) { return <SkeletonLoader width="100" height="15" />; }

    return (
        <div>
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.countText} data-test-selector="productListCountText">
                    <Typography {...styles.showingText}>Showing&nbsp; </Typography>
                    {`${start} - ${end} of ${total}`}
                </Typography>
            </StyledWrapper>
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: withCoveoHooks(CoveoQuerySummary),
    definition: {
        group: "Product List",
        displayName: "Coveo Query Summary",
    },
};
export default widgetModule;
